<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        <el-form-item class="search-customer-from-pc">
          <el-select
            v-model="query.pid"
            clearable
            filterable
            remote
            reserve-keyword
            :remote-method="getProduct"
            :loading="productloading"
            placeholder="商品名称 / 编号 / 条形码"
            @change="issearchchange = true"
          >
            <el-option
              v-for="(item, index) in productlists"
              :key="index"
              :label="item.showname"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getsearch">查询</el-button>
        </el-form-item>
      </el-form>

      <!-- 搜索商品信息 -->
      <div class="showfrozenstat" v-loading="query.loading">
        <span class="frozenstatstyle1">
          商品信息：
          {{ lists.brandname ? '【' + lists.brandname + '】' : '' }}
          {{ lists.name }}
          {{ lists.spec ? ' [' + lists.spec + ']' : '' }}
          {{ lists.id ? '（商品id：' + lists.id : '' }}
          {{ lists.number ? '，编号：' + lists.number + '）' : '' }}
        </span>
        <span class="frozenstatstyle2">查询仓库：{{ lists.warehouse }}</span>
        <span class="frozenstatstyle2">当前库存数量：<i>{{ lists.inventorys }}</i></span>
        <span class="frozenstatstyle2">冻结数量：<i>{{ lists.frozen }}</i></span>
        <span class="frozenstatstyle2">可用库存数量：<i>{{ lists.lastinventory }}</i></span>
      </div>

      <div style="clear: both;"></div>

      <div class="warehouseList">
        <div class="title">查询仓库：单个仓库</div>
        <el-table :data="singleWarehouse" border style="width: 100%;">
          <el-table-column prop="name" label="仓库名称" align="center"></el-table-column>
          <el-table-column prop="all_inventory" label="当前库存数量" align="center"></el-table-column>
          <el-table-column prop="lock_inventory" label="冻结库存数量" align="center"></el-table-column>
          <el-table-column prop="inventory" label="可用库存数量" align="center"></el-table-column>
        </el-table>
      </div>

      <div style="clear: both;"></div>

      <div class="separate-title" style="margin-top:26px;" v-if="lists.lists.length > 0">冻结库存明细</div>

      <!-- 开启货位批次 展示的表格 -->
      <div v-if="storageLocationStatus" class="frozenout" v-loading="query.loading">
        <div class="showfrozen" v-for="(item, index) in lists.lists" :key="index">
          <span class="showfrozentitle">{{ item.title }}（冻结数量：<i>{{ item.numbers }}</i>）</span>

          <div>
            <el-table
              :data="item.firstList"
              :span-method="(param) => objectSpanMethod(param, item)"
              :border="true"
              style="margin-top:10px;"
            >
              <!-- 线上商城未发货商品 -->
              <template v-if="isTitle(item.title, '线上商城未发货商品')">
                <el-table-column prop="id" label="ID" align="center"></el-table-column>
                <el-table-column prop="name" label="单号" align="center"></el-table-column>
                <el-table-column prop="status" label="订单状态" align="center"></el-table-column>
                <el-table-column prop="inventory" label="数量" align="center"></el-table-column>
              </template>

              <!-- 供应商代发订单（✅ 修复：不再参与合并单元格，避免两条变一条） -->
              <template v-if="isTitle(item.title, '供应商代发订单')">
                <el-table-column prop="id" label="ID" align="center"></el-table-column>

                <el-table-column prop="ordernumber" label="单号" align="center">
                  <template slot-scope="scope">
                    <!-- ordernumber 为 null 时这里显示空，但不会影响整行显示 -->
                    <span v-if="scope.row.ordernumber">{{ scope.row.ordernumber }}</span>
                    <span v-else>/</span>
                  </template>
                </el-table-column>

                <el-table-column prop="order_sn" label="关联代发单号" align="center"></el-table-column>
                <el-table-column prop="status" label="订单状态" align="center"></el-table-column>
                <el-table-column prop="inventory" label="数量" align="center"></el-table-column>
              </template>

              <!-- 线上商城未发货赠品 -->
              <template v-if="isTitle(item.title, '线上商城未发货赠品')">
                <el-table-column prop="id" label="ID" align="center"></el-table-column>
                <el-table-column prop="name" label="单号" align="center"></el-table-column>
                <el-table-column prop="status" label="订单状态" align="center"></el-table-column>
                <el-table-column prop="inventory" label="数量" align="center"></el-table-column>
              </template>

              <!-- 销售出库单 -->
              <template v-if="isTitle(item.title, '销售出库单')">
                <el-table-column prop="id" label="ID" align="center"></el-table-column>
                <el-table-column prop="name" label="单号" align="center"></el-table-column>
                <el-table-column prop="icon" label="下单来源" align="center"></el-table-column>

                <el-table-column prop="inventory" label="数量" align="center">
                  <template slot-scope="scope">
                    {{ getInventory(item.firstList, scope.row.name) }}
                  </template>
                </el-table-column>

                <el-table-column label="仓库：货位：冻结库存" align="center" width="300px">
                  <template slot-scope="scope">
                    <span>{{ scope.row.warehouse_name }}</span>
                    <span>{{ scope.row.full_code }}</span>
                    <span v-if="scope.row.numbers">：</span>
                    <span>{{ scope.row.numbers }}</span>
                  </template>
                </el-table-column>

                <el-table-column v-if="batchStatus" prop="batch_sn" label="批次" align="center" width="150px"></el-table-column>

                <el-table-column v-if="batchStatus" prop="start_date" label="生产日期" align="center" width="150px">
                  <template slot-scope="scope">
                    <span>{{ scope.row.start_date || '/' }}</span>
                  </template>
                </el-table-column>

                <el-table-column v-if="batchStatus" label="有效期" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.realvalidity }} {{ validityunitTemp[scope.row.validityunit] }}</span>
                  </template>
                </el-table-column>

                <el-table-column v-if="batchStatus" prop="end_date" label="到期日期" align="center" width="150px">
                  <template slot-scope="scope">
                    <span>{{ scope.row.end_date || '/' }}</span>
                  </template>
                </el-table-column>
              </template>

              <!-- 线上商城改单商品 -->
              <template v-if="isTitle(item.title, '线上商城改单商品')">
                <el-table-column prop="id" label="ID" align="center"></el-table-column>
                <el-table-column prop="name" label="单号" align="center"></el-table-column>
                <el-table-column prop="status" label="订单状态" align="center"></el-table-column>
                <el-table-column prop="inventory" label="数量" align="center"></el-table-column>
              </template>

              <!-- 开单页面挂起 -->
              <template v-if="isTitle(item.title, '开单页面挂起')">
                <el-table-column prop="name" label="开单人员" align="center"></el-table-column>
                <el-table-column prop="inventory" label="数量" align="center"></el-table-column>
              </template>

            </el-table>
          </div>
        </div>
      </div>

      <!-- 不开启货位批次 -->
      <div v-if="!storageLocationStatus" class="frozenout" style="width: 400px;" v-loading="query.loading">
        <div class="showfrozen" v-for="(item, index) in lists.lists" :key="index">
          <span class="showfrozentitle">{{ item.title }}（冻结数量：<i>{{ item.numbers }}</i>）</span>
          <div style="clear: both;"></div>

          <div style="margin-top: 10px; display: flex; flex-direction: column;">
            <div v-for="(tt, ii) in item.data" :key="ii" style="display: flex; align-items: center;">
              <i class="icon-dian"></i>
              <span class="ordernumbersid" v-if="tt.id > 0">id:{{ tt.id }}</span>
              <span class="ordernumbers" v-if="tt.name != ''">
                {{ tt.name }}
                <i v-if="tt.icon != ''">{{ tt.icon }}</i>

                <span
                  v-if="isTitle(item.title, '供应商代发订单') && tt.relation_order"
                  style="margin-left: 5px; color: #666;"
                >
                  (关联单号:{{ tt.relation_order }})
                </span>
              </span>

              <span class="frozenstatus" v-if="tt.status != ''">{{ tt.status }}</span>
              <span class="frozennums" v-if="tt.inventory" style="float: right;">{{ tt.inventory }}</span>

              <span style="float: left;max-width: 200px;min-width:180px;" v-if="goodsLocationStatus">
                <span class="storage-location" v-if="tt.storage_location && tt.storage_location.length > 0">
                  (<span v-for="(location_, location_idx) in tt.storage_location" :key="location_idx">
                    {{ location_.warehouse_name }}{{ location_.full_code }}:{{ location_.numbers }};
                  </span>)
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div style="clear: both;"></div>

      <div class="separate-title" v-if="availableLists.lists.length > 0">可用库存明细</div>

      <!-- 开启货位批次展示 -->
      <div class="frozenout" v-if="availableLists.lists.length > 0 && storageLocationStatus">
        <div class="showfrozen">
          <span class="showfrozentitle">可用库存（数量：<i>{{ availableLists.total }}</i>）</span>
          <div>
            <table class="inventory-table">
              <thead>
                <tr>
                  <th>货位</th>
                  <th>可用库存</th>
                  <th v-if="batchStatus">批次效期</th>
                </tr>
              </thead>

              <tbody v-for="(outSide, outSideIdx) in availableLists.lists" :key="outSideIdx">
                <tr>
                  <td colspan="3" class="warehouse-title">{{ outSide.name }}（数量：{{ outSide.inventory }}）</td>
                </tr>
                <tr v-for="(inSide, inSideIdx) in outSide.storage_location_items" :key="inSideIdx">
                  <td class="location-cell">{{ inSide.full_code }}</td>
                  <td>{{ inSide.available_number }}</td>
                  <td v-if="batchStatus" class="batch-cell">
                    <div v-for="(batch, batchIndex) in inSide.child" :key="batchIndex">
                      <span>{{ batch.batch_sn }}</span>
                      <span v-if="batch.start_date">[{{ batch.start_date }}至{{ batch.end_date }}]</span>
                      <span v-if="batch.numbers > 0" style="margin-left: 5px;color:red;">{{ batch.numbers }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 不开启货位批次展示 -->
      <div class="frozenout" style="width: 400px;" v-if="availableLists.lists.length > 0 && !storageLocationStatus">
        <div class="showfrozen">
          <span class="showfrozentitle">可用库存（数量：<i>{{ availableLists.total }}</i>）</span>
          <div class="frozencontent">
            <ul v-for="(outSide, outSideIdx) in availableLists.lists" :key="outSideIdx">
              <li style="padding:0px 18px;box-sizing: border-box;background:#F1F5F8;border-bottom: 1px solid #dddddd;">
                <span class="ordernumbersid">{{ outSide.name }}（数量：{{ outSide.inventory }}）</span>
              </li>
              <section v-if="goodsLocationStatus">
                <li
                  v-for="(inSide, inSideIdx) in outSide.storage_location_items"
                  :key="inSideIdx"
                  style="padding:0px 20px;box-sizing: border-box;background: rgb(241, 245, 248,0.4)"
                >
                  <span class="ordernumbersid">{{ inSide.full_code }}</span>
                  <span class="frozennums">{{ inSide.available_number }}</span>
                </li>
              </section>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </transition>
</template>

<script>
export default {
  props: ['childdata'],
  data() {
    return {
      url: this.GLOBAL.domain + "Inventory/index",
      transitionshow: true,
      productid: '',
      query: {
        act: 'getproductfrozen',
        token: this.$cookies.get('token'),
        warehouse: '',
        pid: '',
        loading: false,
      },
      lists: { lists: [] },
      issearchchange: false,
      warehouselists: [],
      productlists: [],
      productloading: false,

      checkgoodsinfos: {},
      isinitialization_frozen: false,
      availableLists: { lists: [], total: '' },
      goodsLocationStatus: false,
      validityunitTemp: {
        1: '天',
        2: '月',
        3: '年'
      },
      batchStatus: false,
      storageLocationStatus: false
    }
  },
  computed: {
    singleWarehouse () {
      const list = Array.isArray(this.availableLists.lists) ? this.availableLists.lists : []
      return list.filter(item => {
        const inv = Number(item.inventory) || 0
        const all = Number(item.all_inventory) || 0
        const lock = Number(item.lock_inventory) || 0
        return inv > 0 || all > 0 || lock > 0
      })
    },
  },
  created() {
    this.storageLocationStatus = localStorage.getItem('storageLocationStatus') === "true"
    this.batchStatus = localStorage.getItem('batchStatus') === 'true'
  },
  mounted() {
    this.productid = this.childdata.id
    this.getWarehouse()
    this.checkLocationStatus()

    this.checkgoodsinfos = this.childdata.goodsinfo
    if (this.checkgoodsinfos) this.initialization_frozen()
  },
  watch: {
    childdata(val) {
      if (val.goodsinfo) {
        this.checkgoodsinfos = this.childdata.goodsinfo
        this.initialization_frozen()
      }
    },
  },
  methods: {
    isTitle(title, name) {
      return String(title || '').indexOf(name) > -1
    },

    // ✅ 只对“销售出库单”启用合并
    shouldMergeByTitle(title) {
      return this.isTitle(title, '销售出库单')
    },

    // ✅ 只合并“销售出库单”的前4列：ID/单号/来源/数量；不合并货位列
    getMergeColumnCount(title) {
      if (this.isTitle(title, '销售出库单')) return 4
      return 0
    },

    objectSpanMethod({ rowIndex, columnIndex }, item) {
      const title = item && item.title ? item.title : ''
      const data = item && item.firstList ? item.firstList : []

      const mergeCols = this.getMergeColumnCount(title)
      if (!this.shouldMergeByTitle(title) || mergeCols <= 0) {
        return { rowspan: 1, colspan: 1 }
      }

      if (columnIndex >= mergeCols) {
        return { rowspan: 1, colspan: 1 }
      }

      const spanMap = this.calculateSpanMap(data)
      const span = spanMap[rowIndex]
      if (span) {
        return { rowspan: span.rowspan, colspan: 1 }
      }
      return { rowspan: 0, colspan: 0 }
    },

    // 合并规则：按 row.name（销售出库单的单号）分组
    calculateSpanMap(data) {
      const spanMap = {}
      let currentKey = null
      let count = 0
      let startIndex = 0

      data.forEach((row, index) => {
        const key = row && row.name != null ? row.name : null
        if (key !== currentKey) {
          if (currentKey !== null) {
            spanMap[startIndex] = { rowspan: count }
            for (let j = startIndex + 1; j < startIndex + count; j++) {
              spanMap[j] = { rowspan: 0 }
            }
          }
          currentKey = key
          count = 1
          startIndex = index
        } else {
          count++
        }
      })

      if (currentKey !== null) {
        spanMap[startIndex] = { rowspan: count }
        for (let j = startIndex + 1; j < startIndex + count; j++) {
          spanMap[j] = { rowspan: 0 }
        }
      }
      return spanMap
    },

    initialization_frozen() {
      this.isinitialization_frozen = true
      const key = (this.checkgoodsinfos.number && this.checkgoodsinfos.number !== '')
        ? this.checkgoodsinfos.number
        : this.checkgoodsinfos.name
      this.getProduct(key)
    },

    getWarehouse() {
      var resource = this.$resource(this.GLOBAL.domain + "Ware/index")
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message)
        } else {
          this.warehouselists = JSON.parse(Base64.decode(res.data.Data))
        }
      }).catch(() => {
        this.$message.error(this.GLOBAL.errortext)
      })
    },

    // 根据单号获取数量总和（更健壮：支持 numbers/inventory 是字符串）
    getInventory(list, name) {
      const rows = (Array.isArray(list) ? list : []).filter(item => item.name == name)
      return rows.reduce((acc, cur) => {
        const raw = (cur && cur.numbers != null) ? cur.numbers : (cur ? cur.inventory : 0)
        const n = Number(raw)
        return acc + (isNaN(n) ? 0 : n)
      }, 0)
    },

    getProduct(key) {
      this.productloading = true
      var resource = this.$resource(this.url)
      resource.save({ act: 'getfrozenproduct', token: this.$cookies.get('token'), rollpage: 1000, key }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message)
          this.productloading = false
          return
        }

        this.productlists = JSON.parse(Base64.decode(res.data.Data))
        this.productloading = false

        if (this.checkgoodsinfos && this.isinitialization_frozen) {
          this.isinitialization_frozen = false
          setTimeout(() => {
            this.query.pid = this.checkgoodsinfos.id
            this.getsearch()
          }, 50)
        }
      }).catch(() => {
        this.$message.error(this.GLOBAL.errortext)
        this.productloading = false
      })
    },

    getsearch() {
      this.query.loading = true
      var resource = this.$resource(this.url)

      resource.save(this.query).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message)
          this.query.loading = false
          return
        }

        this.lists = JSON.parse(Base64.decode(res.data.Data))
        this.query.loading = false

        // 生成 firstList（把 storage_location 展开）
        this.lists.lists.forEach(element => {
          element.firstList = this.buildFirstList(element)
        })

        // ✅ 放到这里，保证 pid/warehouse 等已准备好
        this.availableInventory()
      }).catch(() => {
        this.$message.error(this.GLOBAL.errortext)
        this.query.loading = false
      })
    },

    buildFirstList(element) {
      const arr = []
      const data = Array.isArray(element.data) ? element.data : []

      data.forEach(d => {
        const locs = Array.isArray(d.storage_location) ? d.storage_location : []
        if (locs.length) {
          locs.forEach(loc => {
            arr.push({
              ...loc,
              id: d.id,
              name: d.name,
              icon: d.icon,
              inventory: d.inventory,
              order_sn: d.order_sn,
              ordernumber: d.ordernumber,
              status: d.status,
              pay_status: d.pay_status,
              unit: d.unit,
              relation_order: d.relation_order,
            })
          })
        } else {
          arr.push(d)
        }
      })

      return arr
    },

    availableInventory() {
      const address_url = this.GLOBAL.domain + "Inventory/inventory_detail"
      var resource = this.$resource(address_url)
      const sendData = {
        product_id: this.query.pid,
        warehouse_id: this.query.warehouse,
        token: this.$cookies.get('token'),
      }
      resource.save(sendData).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message)
        } else {
          this.availableLists = JSON.parse(Base64.decode(res.data.Data))
        }
      }).catch(() => {
        this.$message.error(this.GLOBAL.errortext)
      })
    },

    checkLocationStatus() {
      const goodsLocationStatus = localStorage.getItem("storageLocationStatus") || ''
      this.goodsLocationStatus = (goodsLocationStatus === "true")
    },
  }
}
</script>

<style>
/* ✅ 你的样式原封不动 */
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}
.warehouseList {
  padding: 20px;
  border-radius: 15px;
  background-color: #fff;
  margin-top: 30px;
  box-shadow: 5px 5px 10px #999999;
  width: 95%;
}
.warehouseList .title {
  margin-bottom: 10px;
}
.showfrozenstat {
  float: left;
  width: calc(100% - 40px);
  margin-top: 10px;
  padding: 10px 20px;
  border-radius: 15px;
  background: #fff;
}

.showfrozen {
  float: left;
  width: 95%;
  padding: 10px 1%;
  background: #fff;
  margin: 0 1% 20px 0;
  border-radius: 15px;
  border: 1px solid #dddddd;
  box-shadow: 5px 5px 10px #999999;
  overflow: hidden
}

.showfrozentitle {
  float: left;
  width: 98%;
  padding: 5px 0 5px 2%;
  border-bottom: 1px solid #dddddd;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.showfrozentitle i {
  font-style: normal;
  font-weight: 550;
  color: #F56C6C;
}

.frozencontent {
  float: left;
  width: 96%;
  padding: 0 2%;
  overflow-y: scroll;
  height: 250px;
}

.frozencontent::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.frozencontent ul {
  padding: 0;
  margin: 5px 0
}

.frozencontent li {
  float: left;
  width: 100%;
  padding: 5px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  list-style-type: none;
  font-size: 13px;
  color: #666666
}

.ordernumbersid {
  float: left;
  width: 80px
}

.ordernumbers {
  float: left;
  margin-right: 5px;
  margin-left: 5px
}

.ordernumbers i {
  font-style: normal;
  font-size: 12px;
  border-radius: 15px;
  padding: 1px 8px;
  color: #fff;
  background: #F56C6C;
  margin-left: 2px
}

.frozenstatus {
  float: left;
  margin-left: 5%
}

.frozennums {
  float: right;
  font-weight: 550;
  color: #F56C6C
}

.frozenout {
  float: left;
  width: 100%;
  margin-top: 10px;
}

.frozenstatstyle1 {
  float: left;
  width: 100%;
  font-size: 13px;
  color: #333336;
  padding: 10px 0 0 0;
}

.frozenstatstyle2 {
  float: left;
  margin-right: 30px;
  font-size: 13px;
  color: #666663;
  line-height: 23px;
  padding: 10px 0 0 0;
}

.frozenstatstyle2 i {
  font-style: normal;
  font-weight: bold;
  color: #F56C6C;
  line-height: 23px
}

.separate-title {
  font-size: 15px;
  margin-top: 10px;
  line-height: normal;
}

.storage-location {
  display: inline-block;
  white-space: normal;
  width: 100%;
}
</style>

<style scoped>
.icon-dian {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  overflow: hidden;
  background-color: black;
  margin-right: 10px;
  margin-left: 10px;
}
.inventory-table {
  width: 100%;
  border-collapse: collapse;
  margin: 16px 0;
  font-family: Arial, sans-serif;
}

.inventory-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  padding: 8px 12px;
  text-align: left;
  border-bottom: 2px solid #ddd;
}

.inventory-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
}

.warehouse-title {
  font-weight: bold;
  padding: 8px 12px;
}

.section-divider {
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/inventory/frozen.vue